/* Drankjestester – theme.js (geen dependencies) */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const T = window.theme || { routes: {}, strings: {} };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '€{{amount_with_comma_separator}}';
    const fmt = (n, dec = 2, th = '.', d = ',') => {
      n = (n / 100).toFixed(dec);
      const parts = n.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
      return dec ? parts[0] + d + parts[1] : parts[0];
    };
    const m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return format;
    let v;
    switch (m[1]) {
      case 'amount': v = fmt(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': v = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2, '.', ',');
    }
    return format.replace(m[0], v);
  }

  /* ---------- Header scroll shadow ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile menu ---------- */
  const menu = $('[data-mobile-menu]');
  if (menu) {
    const setMenu = (open) => {
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', String(!open));
      document.body.classList.toggle('no-scroll', open);
    };
    $$('[data-menu-open]').forEach((b) => b.addEventListener('click', () => setMenu(true)));
    menu.addEventListener('click', (e) => { if (e.target.closest('[data-menu-close]')) setMenu(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setMenu(false); });
  }

  /* ---------- Reveal on scroll ---------- */
  const reveals = $$('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }
  document.addEventListener('shopify:section:load', () => $$('.reveal').forEach((el) => el.classList.add('is-visible')));

  /* ---------- Toast ---------- */
  function toast(msg) {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = '<svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' + msg;
    requestAnimationFrame(() => t.classList.add('is-visible'));
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('is-visible'), 2600);
  }

  /* ---------- Cart ---------- */
  const Cart = {
    sectionId: 'cart-drawer',
    get wrap() { return document.getElementById('shopify-section-cart-drawer'); },
    get drawer() { return $('[data-cart-drawer]'); },
    open() {
      const d = this.drawer; if (!d) return false;
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      const c = $('[data-cart-close].icon-btn', d); c && c.focus({ preventScroll: true });
      return true;
    },
    close() {
      const d = this.drawer; if (!d) return;
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
    },
    render(sections, keepOpen = true) {
      if (!sections) return;
      const html = sections[this.sectionId];
      if (html && this.wrap) {
        const tmp = document.createElement('div'); tmp.innerHTML = html;
        const fresh = $('[data-cart-drawer]', tmp);
        if (fresh) {
          if (keepOpen) { fresh.classList.add('is-open'); fresh.setAttribute('aria-hidden', 'false'); }
          this.drawer.replaceWith(fresh);
        }
      }
    },
    updateCount(count) {
      $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.dataset.count = count; });
    },
    async refreshCount() {
      try { const r = await fetch(T.routes.cart + '.js'); const c = await r.json(); this.updateCount(c.item_count); return c; } catch (e) { return null; }
    },
    async add(formData) {
      formData.append('sections', this.sectionId);
      formData.append('sections_url', window.location.pathname);
      const r = await fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData });
      const data = await r.json();
      if (!r.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      return data;
    },
    async change(line, quantity) {
      const r = await fetch(T.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: [this.sectionId], sections_url: window.location.pathname })
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || T.strings.error);
      this.render(data.sections);
      this.updateCount(data.item_count);
      return data;
    }
  };
  window.DTCart = Cart;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && T.cartDrawer && Cart.drawer) { e.preventDefault(); Cart.open(); return; }
    if (e.target.closest('[data-cart-close]')) { Cart.close(); return; }
    const q = e.target.closest('[data-qty-change]');
    if (q) {
      const item = q.closest('[data-line]');
      if (!item) return;
      const line = Number(item.dataset.line);
      const qty = Math.max(0, Number(q.dataset.qtyChange));
      item.style.opacity = '.5';
      const onPage = q.closest('[data-cart-page]');
      if (onPage) {
        fetch(T.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity: qty }) })
          .then(() => window.location.reload());
      } else {
        Cart.change(line, qty).catch((err) => { item.style.opacity = '1'; toast(err.message); });
      }
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;
    const btn = input.closest('[data-line]').querySelector('[data-qty-change]');
    btn.dataset.qtyChange = Math.max(0, parseInt(input.value, 10) || 0);
    btn.click();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') Cart.close(); });
  window.addEventListener('pageshow', (e) => { if (e.persisted) Cart.refreshCount(); });

  /* ---------- Product section ---------- */
  function initProduct(section) {
    if (!section || section.dataset.ready) return;
    section.dataset.ready = '1';
    const jsonEl = $('[data-product-json]', section);
    const data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    const form = $('form[action*="/cart/add"]', section);
    const idInput = $('[data-variant-id]', section);
    const qtyInput = $('[data-quantity]', section);
    const addBtn = $('[data-add-button]', section);
    const addLabel = $('[data-add-label]', section);
    const errorEl = $('[data-form-error]', section);
    let variant = data.variants.find((v) => String(v.id) === (idInput && idInput.value)) || data.variants[0];

    /* Gallery */
    const gallery = $('[data-gallery]', section);
    const track = gallery && $('[data-gallery-track]', gallery);
    const slides = track ? $$('.gallery__slide', track) : [];
    let current = 0;
    const goTo = (i, smooth = true) => {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    };
    const setActive = (i) => {
      current = i;
      $$('[data-gallery-goto]', gallery).forEach((b) => {
        const on = Number(b.dataset.galleryGoto) === i;
        b.classList.toggle('is-active', on);
        if (on && b.classList.contains('gallery__thumb')) b.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      });
      const prev = $('[data-gallery-prev]', gallery), next = $('[data-gallery-next]', gallery);
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    };
    if (track) {
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== current) setActive(i);
        });
      }, { passive: true });
      gallery.addEventListener('click', (e) => {
        const g = e.target.closest('[data-gallery-goto]');
        if (g) goTo(Number(g.dataset.galleryGoto));
        if (e.target.closest('[data-gallery-prev]')) goTo(Math.max(0, current - 1));
        if (e.target.closest('[data-gallery-next]')) goTo(Math.min(slides.length - 1, current + 1));
      });
      setActive(0);
    }

    /* Offers */
    const offerInputs = $$('[data-offers] input[type="radio"]', section);
    const selectedOffer = () => offerInputs.find((i) => i.checked) || null;
    const syncQty = () => {
      const o = selectedOffer();
      if (o && o.dataset.offerVariant) {
        if (qtyInput) qtyInput.value = 1;
        const v = data.variants.find((x) => String(x.id) === o.dataset.offerVariant);
        if (v && v !== variant) { variant = v; onVariantChange(); return; }
      } else if (qtyInput) {
        qtyInput.value = o ? o.dataset.qty : 1;
      }
      updateSticky();
    };
    const updateOffers = () => {
      offerInputs.forEach((input) => {
        if (input.dataset.offerVariant) return;
        const qty = Number(input.dataset.qty) || 1;
        const disc = Number(input.dataset.discount) || 0;
        const unitBase = Math.max(variant.compare_at_price || 0, variant.price);
        const compare = unitBase * qty;
        const total = Math.round(variant.price * qty * (100 - disc) / 100);
        const save = compare - total;
        const box = input.closest('.offer');
        const set = (sel, val) => { const el = $(sel, box); if (el) el.textContent = val; };
        set('[data-offer-total]', formatMoney(total));
        set('[data-offer-compare]', formatMoney(compare));
        set('[data-offer-per]', formatMoney(Math.round(total / qty)));
        set('[data-offer-save-amount]', formatMoney(save));
        const sv = $('[data-offer-save]', box), cp = $('[data-offer-compare]', box);
        if (sv) sv.hidden = save <= 0;
        if (cp) cp.hidden = save <= 0;
      });
    };
    offerInputs.forEach((i) => i.addEventListener('change', syncQty));

    /* Variant picker */
    const selects = $$('[data-option-index]', section);
    selects.forEach((sel) => sel.addEventListener('change', () => {
      const opts = selects.map((s) => s.value);
      const found = data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      if (found) { variant = found; onVariantChange(); }
    }));

    function onVariantChange() {
      if (idInput) idInput.value = variant ? variant.id : '';
      const price = $('[data-price-current]', section);
      const compare = $('[data-price-compare]', section);
      const saveEl = $('[data-price-save]', section);
      if (price) price.textContent = formatMoney(variant.price);
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compare) { compare.hidden = !onSale; if (onSale) compare.textContent = formatMoney(variant.compare_at_price); }
      if (saveEl) {
        saveEl.hidden = !onSale;
        if (onSale) saveEl.textContent = saveEl.textContent.replace(/\d+\s?%/, Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%');
      }
      const stock = $('[data-stock]', section);
      if (stock) {
        stock.classList.toggle('stock--out', !variant.available);
        const st = $('[data-stock-text]', stock);
        if (st) { if (!st.dataset.inStock) st.dataset.inStock = variant.available ? st.textContent.trim() : ''; st.textContent = variant.available ? (st.dataset.inStock || st.textContent) : T.strings.soldOut; }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? addBtn.dataset.label : T.strings.soldOut;
      }
      if (variant.featured_media_id) {
        const idx = slides.findIndex((s) => s.dataset.mediaId === String(variant.featured_media_id));
        if (idx > -1) goTo(idx);
      }
      if (window.history.replaceState && variant) {
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      updateOffers();
      updateSticky();
    }

    /* Add to cart */
    if (form) {
      form.addEventListener('submit', async (e) => {
        if (!T.cartDrawer || !Cart.drawer) return; // val terug op normale /cart flow
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        addBtn.classList.add('is-loading');
        try {
          const data = await Cart.add(new FormData(form));
          Cart.render(data.sections, false);
          await Cart.refreshCount();
          Cart.open();
        } catch (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        } finally {
          addBtn.classList.remove('is-loading');
        }
      });
    }

    /* Sticky ATC */
    const sticky = $('[data-sticky-atc]', section);
    function updateSticky() {
      if (!sticky) return;
      const o = selectedOffer();
      let total = variant.price;
      if (o && !o.dataset.offerVariant) total = Math.round(variant.price * Number(o.dataset.qty) * (100 - Number(o.dataset.discount || 0)) / 100);
      const p = $('[data-sticky-price]', sticky);
      if (p) p.textContent = formatMoney(total);
    }
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      let footerVisible = false, btnVisible = true;
      const toggle = () => {
        const show = !btnVisible && !footerVisible && addBtn.getBoundingClientRect().top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      };
      new IntersectionObserver(([en]) => { btnVisible = en.isIntersecting; toggle(); }).observe(addBtn);
      const footer = $('.footer');
      if (footer) new IntersectionObserver(([en]) => { footerVisible = en.isIntersecting; toggle(); }).observe(footer);
      $('[data-sticky-add]', sticky).addEventListener('click', () => {
        if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
      });
    }

    syncQty();
    updateOffers();
  }

  /* ---------- Delivery estimate ---------- */
  function initDelivery(el) {
    const min = Number(el.dataset.min || 1), max = Number(el.dataset.max || 3), cutoff = Number(el.dataset.cutoff || 16);
    const addBusinessDays = (date, days) => {
      const d = new Date(date);
      let added = 0;
      while (added < days) { d.setDate(d.getDate() + 1); const wd = d.getDay(); if (wd !== 0 && wd !== 6) added++; }
      return d;
    };
    let start = new Date();
    if (start.getHours() >= cutoff || start.getDay() === 0 || start.getDay() === 6) {
      start = addBusinessDays(start, 0);
      // na de deadline of in het weekend: start pas op de volgende werkdag
      do { start.setDate(start.getDate() + 1); } while (start.getDay() === 0 || start.getDay() === 6);
    }
    const lang = document.documentElement.lang || 'nl';
    const f = (d) => d.toLocaleDateString(lang, { weekday: 'short', day: 'numeric', month: 'short' });
    const out = $('[data-delivery-range]', el);
    if (out) out.textContent = f(addBusinessDays(start, min)) + ' – ' + f(addBusinessDays(start, max));
  }

  const boot = () => {
    $$('[data-product-section]').forEach(initProduct);
    $$('[data-delivery]').forEach(initDelivery);
  };
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();